import {
  Box,
  Checkbox,
  checkboxClasses,
  FormControl,
  FormControlLabel,
  formControlLabelClasses,
  styled,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { C_ERROR } from "~/common/components/icon/Colors";
import { Link, LinkButton } from "~/common/components/Link";
import { PRIVACY_PAGE, TERMS_OF_USE_PAGE } from "~/utils/url/staticUrls";

interface CheckboxProps {
  checked?: boolean;
  error?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxTermsConditions = ({ checked, error, onChange }: CheckboxProps) => {
  const { t } = useTranslation();

  const label = (
    <Box>
      {t("feature.guestCheckout.checkboxes.tc.label")}
      {" * "}
      <Link href={TERMS_OF_USE_PAGE} target="_blank">
        {t("feature.guestCheckout.checkboxes.tc.button")}
      </Link>
    </Box>
  );
  return (
    <StyledFormControl required error={error}>
      <FormControlLabel control={<Checkbox checked={checked} onChange={onChange} />} label={label} />
    </StyledFormControl>
  );
};

const CheckboxPrivacyPolicy = ({ checked, error, onChange }: CheckboxProps) => {
  const { t } = useTranslation();

  const label = (
    <Box>
      {t("feature.guestCheckout.checkboxes.pp.label")}
      {" * "}
      <Link href={PRIVACY_PAGE} target="_blank">
        {t("feature.guestCheckout.checkboxes.pp.button")}
      </Link>
    </Box>
  );
  return (
    <StyledFormControl required error={error}>
      <FormControlLabel control={<Checkbox checked={checked} onChange={onChange} />} label={label} />
    </StyledFormControl>
  );
};

const CheckboxMarketingConsent = ({ checked, error, onChange }: CheckboxProps) => {
  const { t } = useTranslation();
  const [seeMore, setSeeMore] = useState(false);

  const labelKey = `feature.guestCheckout.checkboxes.marketing.label.${seeMore ? "full" : "short"}`;
  const buttonKey = `feature.guestCheckout.checkboxes.marketing.${seeMore ? "seeless" : "seemore"}`;

  const label = (
    <Box>
      {t(labelKey)} <LinkButton onClick={() => setSeeMore(!seeMore)}>{t(buttonKey)}</LinkButton>
    </Box>
  );
  return (
    <StyledFormControl error={error}>
      <FormControlLabel control={<Checkbox checked={checked} onChange={onChange} />} label={label} />
    </StyledFormControl>
  );
};

export const Checkboxes = {
  MarketingConsent: CheckboxMarketingConsent,
  PrivacyPolicy: CheckboxPrivacyPolicy,
  TermsConditions: CheckboxTermsConditions,
};

export const StyledFormControl = styled(FormControl)({
  [`& .${formControlLabelClasses.root}`]: {
    marginRight: 0,
    [`&.Mui-error .${checkboxClasses.root}`]: {
      color: C_ERROR,
    },
  },
  [`& .scha__link`]: {
    display: "inline",
  },
});
